var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarehouseStockBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.34089 1.66666L4.32422 4.69166",
    stroke: "#4E3E91",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6602 1.66666L15.6768 4.69166",
    stroke: "#4E3E91",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66797 6.54167C1.66797 5 2.49297 4.875 3.51797 4.875H16.4846C17.5096 4.875 18.3346 5 18.3346 6.54167C18.3346 8.33333 17.5096 8.20833 16.4846 8.20833H3.51797C2.49297 8.20833 1.66797 8.33333 1.66797 6.54167Z",
    stroke: "#4E3E91",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.13281 11.6667V14.625",
    stroke: "#4E3E91",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9648 11.6667V14.625",
    stroke: "#4E3E91",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.91797 8.33334L4.09297 15.5333C4.35964 17.15 5.0013 18.3333 7.38464 18.3333H12.4096C15.0013 18.3333 15.3846 17.2 15.6846 15.6333L17.0846 8.33334",
    stroke: "#4E3E91",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouseStockBag);
export default __webpack_public_path__ + "static/media/warehouse-stock-bag.1b609c6b6c1d75d1d511a1c63d97aef9.svg";
export { ForwardRef as ReactComponent };